function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-490.000000, -244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "50px_4",
  transform: "translate(270.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  opacity: 0.263555618,
  x: 0,
  y: 0,
  width: 50,
  height: 50
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.7500657,3 C31.8461875,3 32.7709884,3.69868996 33.1352534,4.67618408 L33.1352534,4.67618408 L40.1228224,4.67618408 C42.2601768,4.67618408 44,6.43130668 44,8.59119919 L44,8.59119919 L44,44.0833053 C44,46.2431979 42.2601768,48 40.1228224,48 L40.1228224,48 L9.87884093,48 C7.73982316,48 6,46.2431979 6,44.0833053 L6,44.0833053 L6,8.59287874 C6,6.43298623 7.73982316,4.67618408 9.87884093,4.67618408 L9.87884093,4.67618408 L16.8647466,4.67618408 C17.2290116,3.69868996 18.1571391,3 19.2499343,3 L19.2499343,3 Z M16.6950889,7.34497817 L9.87884093,7.34497817 C9.19854679,7.34497817 8.64466427,7.90426604 8.64466427,8.59119919 L8.64466427,8.59119919 L8.64466427,44.0816258 C8.64466427,44.768559 9.19854679,45.3278468 9.87884093,45.3278468 L9.87884093,45.3278468 L40.1228224,45.3278468 C40.8014532,45.3278468 41.3553357,44.768559 41.3553357,44.0816258 L41.3553357,44.0816258 L41.3553357,8.59119919 C41.3553357,7.90426604 40.8014532,7.34497817 40.1228224,7.34497817 L40.1228224,7.34497817 L33.3049111,7.34497817 L33.3049111,8.80618072 C33.3049111,10.2321129 32.1622166,11.3876386 30.7500657,11.3876386 L30.7500657,11.3876386 L19.2499343,11.3876386 C17.8394467,11.3876386 16.6950889,10.2321129 16.6950889,8.80618072 L16.6950889,8.80618072 L16.6950889,7.34497817 Z M38.0885932,38.702049 L38.0885932,41.1172321 L11.9114068,41.1172321 L11.9114068,38.702049 L38.0885932,38.702049 Z M17.4252823,24.3789049 L17.4252823,37.2240511 L14.2367154,37.2240511 L14.2367154,24.3789049 L17.4252823,24.3789049 Z M23.5379498,20.6436009 L23.5379498,37.2223715 L20.3493828,37.2223715 L20.3493828,20.6436009 L23.5379498,20.6436009 Z M29.6506172,16.0198186 L29.6506172,37.2223715 L26.4620502,37.2223715 L26.4620502,16.0198186 L29.6506172,16.0198186 Z M35.7632846,17.4239167 L35.7632846,37.2223715 L32.5747177,37.2223715 L32.5747177,17.4239167 L35.7632846,17.4239167 Z",
  id: "Combined-Shape",
  fill: "currentColor",
  fillRule: "nonzero"
})))))));

var SvgIconBarKronos = function SvgIconBarKronos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBarKronos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconBarKronos.934a4b94.svg";
export { ForwardRef as ReactComponent };